import {
  Avatar,
  CircularProgress,
  InputAdornment,
  Stack,
  TextField,
  Box,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormControl,
  InputLabel,
  Button,
  Link,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import React, { useMemo, useState } from "react";
import { useSnackbar } from "notistack";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { makeStyles } from "@mui/styles";
import { s3baseUrl } from "src/config/config";
import InfoIcon from "@mui/icons-material/Info";
import ConfirmationWithDescription from "src/components/ConfirmationWithDescription";
import { Icon } from "@iconify/react";
import ToshowExercise from "./component/modalToshowExercise";
import ExerciseHistoryModel from "./component/ExerciseHistoryModel";
import { programme_workout_exercise_history_list_api } from "src/DAL/programmeWorkout/programmeWorkout";
import ModalToShowAnExerciseInfo from "./component/ModalToShowAnExerciseInfo";
import {
  formatWithLeadingZeros,
  getPaceTextinPaces,
  getMihr,
  getKmhr,
  getPaceText,
  getMihrForPace,
  getKmhrForPace,
  getOptionsByValue,
  exercise_history,
  super_set_item_2,
} from "src/utils/constants";

const useStyles = makeStyles(() => ({
  loading2: {
    position: "fixed",
    top: "50%",
    right: "50%",
    zIndex: 1000,
  },
}));

const EMOMExercisesUI = ({
  addArray,
  setaddArray,
  setModalChangeExe,
  memberId,
  mainindex,
  isWorkoutCompleted,
  setIsWorkoutCompleted,
  practiceType,
  member_vdot,
  handleSubmit,
}) => {
  const [historyModalOpenSuperset, setHistoryModalOpenSuperset] =
    useState(false);
  const [openSingleExerciseInfo, setOpenSingleExerciseInfo] = useState(false);
  const [singleExerciseInfo, setSingleExerciseInfo] = useState("");
  const [historyModalData, setHistoryModalData] = useState([]);
  const [openExerciseAlert, setOpenExerciseAlert] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [selectedRound, setSelectedRound] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [detailsData, setDetailsData] = useState("");
  const [exerIndex, setExerIndex] = useState("");
  const [updatedIndexesArray, setUpdatedIndexesArray] = useState([]);
  const [isExerciseForSuperSet, setIsExerciseForSuperSet] = useState(false);
  const classes = useStyles();

  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded((prev) => !prev);
  };

  const maxLength = 250;

  const updateIntervalTime = (
    minutes,
    seconds,
    index,
    exerIndex,
    setIndex,
    name,
  ) => {
    const totalSeconds = minutes * 60 + seconds;
    const list = [...addArray];
    list[mainindex]["emomSets"][index][exerIndex]["set"][setIndex][name] =
      totalSeconds;
    setaddArray(list);
    setModalChangeExe(true);
  };

  const handleMinutesChange = (e, index, exerIndex, setIndex) => {
    const { name, value } = e.target;
    const list = [...addArray];

    const minutes = parseInt(e.target.value) || 0;
    const seconds =
      list[mainindex]["emomSets"][index][exerIndex]["set"][setIndex][name] % 60;
    updateIntervalTime(minutes, seconds, index, exerIndex, setIndex, name);
  };

  const handleSecondsChange = (e, index, exerIndex, setIndex) => {
    const { name, value } = e.target;
    const list = [...addArray];

    let seconds = parseInt(e.target.value) || 0;
    seconds = Math.min(Math.max(seconds, 0), 59); // Ensure the value is between 0 and 60
    const minutes = Math.floor(
      list[mainindex]["emomSets"][index][exerIndex]["set"][setIndex][name] / 60,
    );
    updateIntervalTime(minutes, seconds, index, exerIndex, setIndex, name);
  };

  const handleChangeComplete = (e, index) => {
    const { checked } = e.target;
    const list = [...addArray];
    if (!checked && isWorkoutCompleted) {
      setExerIndex(index);
      setOpenExerciseAlert(true);
      return;
    }
    list[index]["is_completed"] = checked;

    setModalChangeExe(true);
    setaddArray(list);
    if (checked) {
      handleSubmit(true, true);
    }
  };

  const handleAgreeInExerciseSet = () => {
    const list = [...addArray];
    list[exerIndex]["is_completed"] = false;
    setIsWorkoutCompleted(false);
    setModalChangeExe(true);
    setOpenExerciseAlert(false);
    setaddArray(list);
  };

  const handleArrowSuperSet = (value, index, exerIndex) => {
    const list = [...addArray];
    list[mainindex]["emomSets"][index][exerIndex]["open"] = value;
    setaddArray(list);
  };

  const getVdotPace = (index, exerIndex, setIndex) => {
    const list = [...addArray];
    if (
      !list[mainindex]["emomSets"][index][exerIndex]["set"][setIndex]["vdot"]
    ) {
      return;
    }
    const vodt =
      list[mainindex]["emomSets"][index][exerIndex]["set"][setIndex]["vdot"];
    const distanceType =
      list[mainindex]["emomSets"][index][exerIndex]["set"][setIndex][
        "race_type"
      ];
    const paceType =
      list[mainindex]["emomSets"][index][exerIndex]["set"][setIndex][
        "pace_type"
      ];

    const vdot33Object = findPaceObjectByVdot(vodt);
    if (distanceType != "el") {
      list[mainindex]["emomSets"][index][exerIndex]["set"][setIndex]["pace"] =
        vdot33Object[paceType];
      if (!vdot33Object[paceType]) {
        memberId && setOpenPaceAlert(true);
      }
    } else {
      list[mainindex]["emomSets"][index][exerIndex]["set"][setIndex]["pace"] =
        vdot33Object[paceType + "_low"];
      list[mainindex]["emomSets"][index][exerIndex]["set"][setIndex]["paceUp"] =
        vdot33Object[paceType + "_up"];
    }

    setaddArray(list);
  };

  const handleChangeVdotPaceType = (e, index, exerIndex, setIndex) => {
    const { name, value } = e.target;
    const list = [...addArray];
    list[mainindex]["emomSets"][index][exerIndex]["set"][setIndex][name] =
      value;
    setaddArray(list);
    setModalChangeExe(true);
    getVdotPace(index, exerIndex, setIndex);
  };

  const handleChangeVdotDistance = (e, index, exerIndex, setIndex) => {
    const { name, value } = e.target;
    const list = [...addArray];
    list[mainindex]["emomSets"][index][exerIndex]["set"][setIndex][name] =
      value;

    const optionsTypeSArray = getOptionsByValue(value);

    list[mainindex]["emomSets"][index][exerIndex]["set"][setIndex][
      "optionsType"
    ] = optionsTypeSArray;
    list[mainindex]["emomSets"][index][exerIndex]["set"][setIndex][
      "pace_type"
    ] = optionsTypeSArray[0].key;

    setaddArray(list);
    setModalChangeExe(true);

    if (list[mainindex]["emomSets"][index].parameters.includes("Vdot"))
      getVdotPace(index, exerIndex, setIndex);
  };

  const handleChangeEmomSet = (e, index, exerIndex, setIndex) => {
    const { name, value } = e.target;

    const list = [...addArray];
    list[mainindex]["emomSets"][index][exerIndex]["set"][setIndex][name] =
      value;

    setaddArray(list);
    setModalChangeExe(true);
  };
  const handleChangeEmomSetTempo = (e, index, exerIndex, setIndex) => {
    const { name, value } = e.target;
    if (value.length <= 4) {
      const list = [...addArray];
      list[mainindex]["emomSets"][index][exerIndex]["set"][setIndex][name] =
        value;
      setaddArray(list);
      setModalChangeExe(true);
    }
  };

  const handleRearageSetCount = (index, count) => {
    const list = [...addArray];
    const name = "superset_sets";
    const value = count;
    const targetValue = value === "" ? 1 : Math.max(1, parseInt(value, 10));

    list[index][name] = targetValue;

    list[index]?.superSet.forEach((superSetItem) => {
      const currentSetLength = superSetItem.set.length;

      if (currentSetLength < targetValue) {
        const objectsToAdd = targetValue - currentSetLength;

        for (let i = 0; i < objectsToAdd; i++) {
          superSetItem.set.push({
            ...super_set_item_2,
          });
        }
      } else if (currentSetLength > targetValue) {
        superSetItem.set.splice(targetValue);
      }
    });

    setaddArray(list);
    setModalChangeExe(true);
    setHistoryModalOpenSuperset(false);
  };

  const getRounds = (count) => {
    const rounds = [];
    for (let i = 1; i <= count; i++) {
      rounds.push(
        <div
          onClick={() => {
            setSelectedRound(i);
          }}
          className={
            selectedRound == i
              ? "emom-round-count-box me-2 mt-2 "
              : "emom-round-count-box-disable me-2 mt-2"
          }
        >
          <div
            className={
              selectedRound == i
                ? "emom-round-count"
                : "emom-round-count-disable"
            }
          >
            {i}
          </div>
        </div>,
      );
    }
    return rounds;
  };

  const getMinutesForEmom = () => {
    let min = 10;
    let sec = 0;
    const list = [...addArray];
    const rounds = list[mainindex].rounds;
    const moments = list[mainindex].emomSets.length;
    const interval = list[mainindex].time_interval;
    min = formatWithLeadingZeros(
      Math.floor((rounds * moments * interval) / 60),
    );
    sec = formatWithLeadingZeros((rounds * moments * interval) % 60);
    return `${
      Math.floor(interval / 60) +
      " " +
      ":" +
      formatWithLeadingZeros(interval % 60) +
      " " +
      "minute" +
      " " +
      "for" +
      " " +
      min +
      ":" +
      sec
    }`;
  };

  const getMinutesForInterval = (index) => {
    const list = [...addArray];
    const interval = list[mainindex].time_interval;

    if (interval <= 60) {
      return index + 1;
    }
    if (interval % 60 == 0) {
      return `${
        (interval / 60) * index +
        1 +
        " – " +
        ((interval / 60) * index + interval / 60)
      }`;
    }
    let startInterval = interval * index;
    let endtInterval = interval * index + interval;
    let startintervalText =
      interval * index
        ? Math.floor(startInterval / 60) +
          " " +
          ":" +
          formatWithLeadingZeros(startInterval % 60)
        : 0;
    let endIntervalText =
      Math.floor(endtInterval / 60) +
      " " +
      ":" +
      formatWithLeadingZeros(endtInterval % 60);

    return `${startintervalText + " – " + endIntervalText}`;
  };

  useMemo(() => {
    const arraylength = addArray[mainindex].emomSets.length;
    const lastIndex = parseInt(selectedRound) * arraylength;
    const startingIndex = lastIndex - (arraylength - 1);
    let finalArray = [];
    for (let index = startingIndex; index <= lastIndex; index++) {
      finalArray.push(index - 1);
    }
    setUpdatedIndexesArray(finalArray);
  }, [selectedRound]);

  const handleCopySupersetExercise = (value) => {
    const list = [...addArray];
    list[detailsData]["superSet"][exerIndex]["set"] = value.set;
    list[detailsData]["superSet"][exerIndex]["parameters"] = value?.parameters;
    setaddArray(list);
    setModalChangeExe(true);
    handleRearageSetCount(detailsData, list[detailsData].superset_sets);
  };

  const handleSelectSupersetExercise = (value) => {
    const list = [...addArray];

    list[mainindex]["emomSets"][detailsData][exerIndex]["exercise"] = value;
    list[mainindex]["emomSets"][detailsData][exerIndex]["description"] =
      value?.instructions;
    setaddArray(list);
    setModalChangeExe(true);
  };

  const handleHistorySupersetOpen = async (value, mainIndex, exerInde) => {
    setDetailsData(mainIndex);
    setExerIndex(exerInde);
    handleHistorySuperset(value.exercise, mainIndex, exerInde);
  };

  const handleHistorySuperset = async (value, mainIndex, exerInde) => {
    setDetailsData(mainIndex);
    setExerIndex(exerInde);
    let postData = {
      exercise: value?._id,
      member: memberId,
    };
    setHistoryModalData([]);
    setIsLoading(true);
    try {
      let result = await programme_workout_exercise_history_list_api(postData);
      if (result.code == 200) {
        if (!result.exercise_history.length > 0) {
          const list = [...addArray];
          delete list[mainindex]["emomSets"][detailsData][exerIndex]["history"];
          setaddArray(list);

          return;
        }
        let givenExercise = result.exercise_history.map((item) => {
          return exercise_history(item);
        });
        setHistoryModalData(givenExercise);
        const list = [...addArray];
        list[mainindex]["emomSets"][detailsData][exerIndex]["history"] =
          givenExercise;
        setaddArray(list);
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
      setHistoryModalOpenSuperset(true);
    }
  };

  const handleMinutesChangeSets = (e, index, exerIndex, setIndex) => {
    const { name, value } = e.target;
    const list = [...addArray];
    const minutes = parseInt(e.target.value) || 0;
    const seconds =
      list[mainindex]["emomSets"][index][exerIndex]["set"][setIndex][name] % 60;
    updateIntervalTimeSets(minutes, seconds, index, exerIndex, setIndex, name);
  };

  const handleSecondsChangeSets = (e, index, exerIndex, setIndex) => {
    const { name, value } = e.target;
    const list = [...addArray];
    let seconds = parseInt(e.target.value) || 0;
    seconds = Math.min(Math.max(seconds, 0), 59);
    const minutes = Math.floor(
      list[mainindex]["emomSets"][index][exerIndex]["set"][setIndex][name] / 60,
    );
    updateIntervalTimeSets(minutes, seconds, index, exerIndex, setIndex, name);
  };

  const updateIntervalTimeSets = (
    minutes,
    seconds,
    index,
    exerIndex,
    setIndex,
    name,
  ) => {
    const totalSeconds = minutes * 60 + seconds;
    const list = [...addArray];
    list[mainindex]["emomSets"][index][exerIndex]["set"][setIndex][name] =
      totalSeconds;
    setaddArray(list);
    setModalChangeExe(true);
  };

  const handleClickOpen = async (exercise) => {
    setSingleExerciseInfo(exercise);
    setOpenSingleExerciseInfo(true);
  };

  return (
    <div className="my-2">
      {isLoading && (
        <CircularProgress className={classes.loading2} color="primary" />
      )}
      {openExerciseAlert && (
        <ConfirmationWithDescription
          open={openExerciseAlert}
          setOpen={setOpenExerciseAlert}
          title={"Are you sure you want to take this action?"}
          descriotion={`If you uncheck, your points or coins allocated for this ${practiceType} will be deducted.`}
          isJustForOk={false}
          handleAgree={handleAgreeInExerciseSet}
        />
      )}
      {openSingleExerciseInfo && (
        <ModalToShowAnExerciseInfo
          open={openSingleExerciseInfo}
          setOpen={setOpenSingleExerciseInfo}
          Id={singleExerciseInfo}
        />
      )}
      {isExerciseForSuperSet && (
        <ToshowExercise
          open={isExerciseForSuperSet}
          setOpen={setIsExerciseForSuperSet}
          handleChange={handleSelectSupersetExercise}
        />
      )}
      {historyModalOpenSuperset && (
        <ExerciseHistoryModel
          open={historyModalOpenSuperset}
          setOpen={setHistoryModalOpenSuperset}
          data={historyModalData}
          handleChange={setHistoryModalData}
          handleCopyExercise={handleCopySupersetExercise}
        />
      )}
      <div className="characters mt-2">
        <div
          style={{ position: "relative" }}
          className="workout-Superset-card my-1"
        >
          <Box>
            <div className=" mb-3">
              <div className="d-flex align-items-center justify-content-center  my-2">
                <div className="text-center">
                  Every {getMinutesForEmom()} minutes{" "}
                  {addArray[mainindex].rounds} rounds.
                </div>
              </div>
              <div
                className="d-flex align-items-center justify-content-center"
                style={{ flexWrap: "wrap" }}
              >
                <div className="emom-round-title mt-2">Rounds: </div>
                {getRounds(addArray[mainindex].rounds)}
              </div>
            </div>
            <div className="row  justify-content-between align-items-center">
              <div className="col-12 col-md-8 col-lg-10 pe-0 custom_description ">
                {addArray[mainindex].description && (
                  <>
                    <div className="custom_description_title">Instructions</div>
                    <div className="custom_description_text">
                      {isExpanded
                        ? addArray[mainindex].description
                        : `${addArray[mainindex].description.substring(
                            0,
                            maxLength,
                          )}`}
                      {addArray[mainindex].description.length > maxLength && (
                        <span
                          className="toggle-text"
                          style={{
                            color: "var(--portal-theme-primary)",
                            cursor: "pointer",
                            marginLeft: "5px",
                          }}
                          onClick={toggleExpand}
                        >
                          {isExpanded ? "See Less" : "See More"}
                        </span>
                      )}
                    </div>
                  </>
                )}
              </div>
              <div className="col-12 col-md-4 col-lg-2 pe-0"></div>
            </div>
            {addArray[mainindex].emomSets.length > 0 &&
              addArray[mainindex].emomSets.map((item, index) => {
                return (
                  <div className=" my-2 ">
                    <div className="d-flex justify-content-between align-items-center ">
                      <div>
                        Minute{" "}
                        {getMinutesForInterval(updatedIndexesArray[index])}
                      </div>
                    </div>

                    {item.length > 0 &&
                      item.map((exerData, exerIndex) => {
                        let value_data = exerData.set[selectedRound - 1];

                        return (
                          <div className="ms-4 mt-1">
                            <div
                              className="d-flex workout-set-card  "
                              style={{
                                width: "100%",
                                position: "relative",
                                overflow: "hidden",
                              }}
                            >
                              <Box
                                sx={{
                                  position: "relative",
                                  width: "100%",
                                }}
                              >
                                <div className="row  ">
                                  <div
                                    className={`col-sm-12 ${"col-md-6"} col-lg-6 d-flex align-items-center p-0 mt-2 mt-md-0 mt-lg-0 `}
                                  >
                                    <div className="exercise-label-box">
                                      <span className="outer-label">
                                        Exercise
                                      </span>
                                      <div className="d-flex align-items-center justify-content-between">
                                        <div
                                          className="exercise-label w-100"
                                          style={{ cursor: "default" }}
                                        >
                                          <div className="d-flex align-items-center">
                                            {exerData?.exercise?.image
                                              ?.thumbnail_3 && (
                                              <Avatar
                                                sx={{ borderRadius: "5px" }}
                                                alt="User Image"
                                                src={
                                                  s3baseUrl +
                                                  exerData?.exercise?.image
                                                    ?.thumbnail_3
                                                }
                                              />
                                            )}
                                            <div className="label-text ms-1">
                                              {exerData?.exercise?.title
                                                ? exerData?.exercise?.title
                                                : ""}
                                            </div>
                                          </div>
                                        </div>
                                        <div className="exercise-action">
                                          <div style={{ fontSize: "16px" }}>
                                            {exerData?.exercise ? (
                                              <div>
                                                <InfoIcon
                                                  onClick={() =>
                                                    handleClickOpen(
                                                      exerData?.exercise?._id,
                                                    )
                                                  }
                                                  className="d-block"
                                                  fontSize="14px"
                                                  sx={{
                                                    opacity: 0.5,
                                                    cursor: "pointer",
                                                  }}
                                                />
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <Button
                                      sx={{ textTransform: "inherit" }}
                                      size="small"
                                      color="primary"
                                      variant="contained"
                                      className="d-flex align-items-center ms-2 small-contained-dialog-button"
                                      onClick={() => {
                                        handleArrowSuperSet(
                                          !exerData?.open ? true : false,
                                          index,
                                          exerIndex,
                                        );
                                      }}
                                    >
                                      {!exerData?.open ? (
                                        <KeyboardArrowDownIcon
                                          className="bounce"
                                          sx={{
                                            cursor: "pointer",
                                            fontSize: "20px",
                                          }}
                                        />
                                      ) : (
                                        <KeyboardArrowUpIcon
                                          sx={{
                                            cursor: "pointer",
                                            fontSize: "20px",
                                          }}
                                        />
                                      )}

                                      <Typography
                                        variant="body2"
                                        sx={{
                                          // opacity: 0.6,
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        {` Sets ${1}`}
                                      </Typography>
                                    </Button>
                                  </div>

                                  <div
                                    className={`col-sm-12 ${"col-md-6"} col-lg-6 p-0 mt-2 mt-md-0 mt-lg-0 d-flex align-items-center justify-content-start `}
                                  >
                                    <div className="d-flex align-items-center mx-1">
                                      {/* <div
                                            className="d-flex align-items-center ms-3 set-parameters "
                                            onClick={() => {
                                              handleParametersSuperset(
                                                index,
                                                exerIndex
                                              );
                                            }}
                                          >
                                            <Icon
                                              icon="pajamas:labels"
                                              fontSize="10px"
                                            />
                                            <Typography
                                              variant="body2"
                                              sx={{ ml: 0.5 }}
                                            >
                                              {`Parameters`}
                                            </Typography>
                                          </div> */}
                                      {exerData?.exercise && (
                                        <Button
                                          sx={{ textTransform: "inherit" }}
                                          size="small"
                                          color="primary"
                                          variant="contained"
                                          className="d-flex align-items-center ms-2 small-contained-dialog-button"
                                          onClick={() => {
                                            handleHistorySupersetOpen(
                                              exerData,
                                              index,
                                              exerIndex,
                                            );
                                          }}
                                        >
                                          <Icon
                                            icon="fa-solid:history"
                                            fontSize="10px"
                                          />
                                          <Typography
                                            variant="body2"
                                            sx={{ ml: 0.5 }}
                                          >
                                            {`History`}
                                          </Typography>
                                        </Button>
                                      )}
                                    </div>
                                  </div>
                                </div>

                                {
                                  exerData?.open && (
                                    <div className="d-flex align-items-center my-3 workout-card-inset">
                                      {exerData?.parameters.includes("Vdot") &&
                                      !value_data?.vdot ? (
                                        <Stack
                                          direction="row"
                                          spacing={1}
                                          alignItems="center"
                                          justifyContent="start"
                                          sx={{
                                            padding:
                                              exerData.parameters.includes(
                                                "Vdot",
                                              )
                                                ? "9px 0px"
                                                : "",
                                            overflowX: "auto", // Add this line to enable horizontal scrolling
                                            "&::-webkit-scrollbar": {
                                              height: "5px", // Customize the scrollbar height
                                            },
                                            "&::-webkit-scrollbar-thumb": {
                                              backgroundColor: "#888", // Customize the scrollbar thumb color
                                              borderRadius: "5px", // Optional: Customize the thumb border radius
                                            },
                                            "&::-webkit-scrollbar-track": {
                                              backgroundColor: "#f1f1f1", // Optional: Customize the track color
                                            },
                                          }}
                                        >
                                          <Typography
                                            variant="subtitle2"
                                            sx={{
                                              opacity: 0.6,
                                              fontWeight: "600",
                                              fontSize: "12px",
                                            }}
                                          >
                                            Auto Pacer is not calculated. Please{" "}
                                            <Link
                                              component={RouterLink}
                                              variant="subtitle2"
                                              to={`/edit-profile`}
                                            >
                                              Click here
                                            </Link>{" "}
                                            to calculate it.
                                          </Typography>
                                        </Stack>
                                      ) : (
                                        <div className="row w-100">
                                          {exerData?.parameters.includes(
                                            "Vdot",
                                          ) && (
                                            <>
                                              <div
                                                className={`col-12 col-md-5 ${
                                                  value_data?.race_type == "el"
                                                    ? "col-lg-3"
                                                    : "col-lg-3"
                                                } pe-0 py-2`}
                                              >
                                                <TextField
                                                  id="outlined-basic"
                                                  variant="outlined"
                                                  label="Type"
                                                  InputLabelProps={{
                                                    className:
                                                      "textfiels-input-label",
                                                    shrink: true,
                                                    style: {
                                                      fontSize: "14px",
                                                    },
                                                  }}
                                                  InputProps={{
                                                    className:
                                                      "textfiels-input-value",
                                                    style: {
                                                      fontSize: "13px",
                                                      paddingLeft: "0px",
                                                      paddingRight: "0px",

                                                      justifyContent: "center",
                                                    },
                                                    readOnly: true,
                                                    endAdornment: (
                                                      <InputAdornment
                                                        position="end"
                                                        style={{
                                                          display: "flex",
                                                          alignItems: "center",
                                                        }}
                                                      >
                                                        <Select
                                                          id="select-option"
                                                          variant="outlined"
                                                          size="small"
                                                          name="race_type"
                                                          value={
                                                            value_data?.race_type
                                                          }
                                                          label="Weight Type"
                                                          readOnly={true}
                                                          inputProps={{
                                                            style: {
                                                              padding: 0,
                                                            },
                                                            readOnly: true,
                                                          }}
                                                          onChange={(e) => {
                                                            handleChangeVdotDistance(
                                                              e,
                                                              index,
                                                              exerIndex,
                                                              selectedRound - 1,
                                                            );
                                                          }}
                                                          sx={{
                                                            "& legend": {
                                                              display: "none",
                                                            },
                                                            "& fieldset": {
                                                              top: 0,
                                                            },
                                                            fontSize: "13px",
                                                            border: "none",
                                                            "& fieldset": {
                                                              border: "none",
                                                            },
                                                            "& .MuiOutlinedInput-input":
                                                              {
                                                                padding: 0,
                                                              },
                                                          }}
                                                        >
                                                          <MenuItem value="el">
                                                            Easy/Long
                                                          </MenuItem>
                                                          <MenuItem value="c">
                                                            Compromised
                                                          </MenuItem>
                                                          <MenuItem value="t">
                                                            Threshold
                                                          </MenuItem>
                                                          <MenuItem value="i">
                                                            Interval
                                                          </MenuItem>
                                                          <MenuItem value="r">
                                                            Repitition
                                                          </MenuItem>
                                                        </Select>

                                                        <Select
                                                          id="select-option"
                                                          variant="outlined"
                                                          size="small"
                                                          name="pace_type"
                                                          value={
                                                            value_data?.pace_type
                                                          }
                                                          label="Weight Type"
                                                          readOnly={true}
                                                          inputProps={{
                                                            style: {
                                                              padding: 0,
                                                            },
                                                            readOnly: true,
                                                          }}
                                                          onChange={(e) => {
                                                            handleChangeVdotPaceType(
                                                              e,
                                                              index,
                                                              exerIndex,
                                                              selectedRound - 1,
                                                            );
                                                          }}
                                                          sx={{
                                                            "& legend": {
                                                              display: "none",
                                                            },
                                                            "& fieldset": {
                                                              top: 0,
                                                            },
                                                            fontSize: "13px",
                                                            border: "none",
                                                            "& fieldset": {
                                                              border: "none",
                                                            },
                                                            "& .MuiOutlinedInput-input":
                                                              {
                                                                padding: 0,
                                                              },
                                                          }}
                                                        >
                                                          {value_data?.optionsType?.map(
                                                            (option) => {
                                                              return (
                                                                <MenuItem
                                                                  key={
                                                                    option?.key
                                                                  }
                                                                  value={
                                                                    option?.key
                                                                  }
                                                                >
                                                                  {
                                                                    option?.title
                                                                  }
                                                                </MenuItem>
                                                              );
                                                            },
                                                          )}
                                                        </Select>
                                                      </InputAdornment>
                                                    ),
                                                  }}
                                                  sx={{
                                                    borderRadius: "5px",
                                                    fontSize: "13px",
                                                    "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                                                      {
                                                        width: "0px !important",
                                                        padding:
                                                          "9px 0px !important",
                                                      },
                                                    "& .css-1nuss9t": {
                                                      width: "0px !important",
                                                      padding:
                                                        "9px 0px !important",
                                                    },
                                                    // "& input": {
                                                    //   textAlign: "center",
                                                    //   padding: "0px",
                                                    // },
                                                    width: "100%",
                                                  }}
                                                />
                                              </div>

                                              {value_data?.race_type == "el" ? (
                                                <div
                                                  className={`col-12 col-md-3 col-lg-2 pe-0 py-2`}
                                                >
                                                  <TextField
                                                    id="outlined-basic"
                                                    variant="outlined"
                                                    label={getPaceText(
                                                      value_data?.pace_type,
                                                    )}
                                                    InputLabelProps={{
                                                      className:
                                                        "textfiels-input-label",
                                                      shrink: true,
                                                      style: {
                                                        fontSize: "14px",
                                                      },
                                                    }}
                                                    InputProps={{
                                                      className:
                                                        "textfiels-input-value",
                                                      style: {
                                                        fontSize: "13px",
                                                        paddingLeft: "0px",
                                                        paddingRight: "0px",

                                                        justifyContent:
                                                          "center",
                                                      },

                                                      readOnly: true,
                                                      endAdornment: (
                                                        <InputAdornment
                                                          position="end"
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                          }}
                                                        >
                                                          <TextField
                                                            id="outlined-basic-minutes"
                                                            type="number"
                                                            size="small"
                                                            placeholder="Min"
                                                            name="pace"
                                                            value={formatWithLeadingZeros(
                                                              Math.floor(
                                                                value_data?.pace /
                                                                  60,
                                                              ),
                                                            )}
                                                            readOnly={true}
                                                            onChange={(e) =>
                                                              handleMinutesChange(
                                                                e,
                                                                index,
                                                                exerIndex,
                                                                selectedRound -
                                                                  1,
                                                              )
                                                            }
                                                            InputProps={{
                                                              className:
                                                                "textfiels-input-value",
                                                              style: {
                                                                fontSize:
                                                                  "14px",
                                                                // width: "40px",
                                                              },
                                                              readOnly: true,
                                                            }}
                                                            sx={{
                                                              "& fieldset": {
                                                                border: "none",
                                                              },
                                                              // "& .css-1j6hc4w-MuiInputBase-input-MuiOutlinedInput-input":
                                                              //   {
                                                              //     padding: "0px !important",
                                                              //   },
                                                              "& input": {
                                                                textAlign:
                                                                  "center",
                                                                padding: "0px",
                                                              },
                                                              width: "100%",
                                                            }}
                                                          />
                                                          <div className="fs-6 fw-semibold ms-1 ">
                                                            :
                                                          </div>

                                                          <TextField
                                                            id="outlined-basic-seconds"
                                                            type="number"
                                                            size="small"
                                                            placeholder="Sec"
                                                            name="pace"
                                                            value={formatWithLeadingZeros(
                                                              value_data?.pace %
                                                                60,
                                                            )}
                                                            onChange={(e) =>
                                                              handleSecondsChange(
                                                                e,
                                                                index,
                                                                exerIndex,
                                                                selectedRound -
                                                                  1,
                                                              )
                                                            }
                                                            InputProps={{
                                                              className:
                                                                "textfiels-input-value",
                                                              style: {
                                                                fontSize:
                                                                  "14px",
                                                                // width: "40px",
                                                              },
                                                              readOnly: true,
                                                            }}
                                                            sx={{
                                                              "& fieldset": {
                                                                border: "none",
                                                              },
                                                              // "& .css-1j6hc4w-MuiInputBase-input-MuiOutlinedInput-input":
                                                              //   {
                                                              //     padding: "0px !important",
                                                              //   },
                                                              "& input": {
                                                                textAlign:
                                                                  "center",
                                                                padding: "0px",
                                                              },
                                                              width: "100%",
                                                            }}
                                                          />
                                                          <div className="fs-6 fw-semibold ms-1 me-1 ">
                                                            -
                                                          </div>
                                                          <TextField
                                                            id="outlined-basic-minutes"
                                                            type="number"
                                                            size="small"
                                                            placeholder="Min"
                                                            name="paceUp"
                                                            value={formatWithLeadingZeros(
                                                              Math.floor(
                                                                value_data?.paceUp /
                                                                  60,
                                                              ),
                                                            )}
                                                            onChange={(e) =>
                                                              handleMinutesChange(
                                                                e,
                                                                index,
                                                                exerIndex,
                                                                selectedRound -
                                                                  1,
                                                              )
                                                            }
                                                            InputProps={{
                                                              className:
                                                                "textfiels-input-value",
                                                              style: {
                                                                fontSize:
                                                                  "14px",
                                                                // width: "40px",
                                                              },
                                                              readOnly: true,
                                                            }}
                                                            sx={{
                                                              "& fieldset": {
                                                                border: "none",
                                                              },
                                                              // "& .css-1j6hc4w-MuiInputBase-input-MuiOutlinedInput-input":
                                                              //   {
                                                              //     padding: "0px !important",
                                                              //   },
                                                              "& input": {
                                                                textAlign:
                                                                  "center",
                                                                padding: "0px",
                                                              },
                                                              width: "100%",
                                                            }}
                                                          />
                                                          <div className="fs-6 fw-semibold ms-1 ">
                                                            :
                                                          </div>

                                                          <TextField
                                                            id="outlined-basic-seconds"
                                                            type="number"
                                                            size="small"
                                                            placeholder="Sec"
                                                            name="paceUp"
                                                            value={formatWithLeadingZeros(
                                                              value_data?.paceUp %
                                                                60,
                                                            )}
                                                            onChange={(e) =>
                                                              handleSecondsChange(
                                                                e,
                                                                index,
                                                                exerIndex,
                                                                selectedRound -
                                                                  1,
                                                              )
                                                            }
                                                            InputProps={{
                                                              className:
                                                                "textfiels-input-value",
                                                              style: {
                                                                fontSize:
                                                                  "14px",
                                                                // width: "40px",
                                                              },
                                                              readOnly: true,
                                                            }}
                                                            sx={{
                                                              "& fieldset": {
                                                                border: "none",
                                                              },
                                                              // "& .css-1j6hc4w-MuiInputBase-input-MuiOutlinedInput-input":
                                                              //   {
                                                              //     padding: "0px !important",
                                                              //   },
                                                              "& input": {
                                                                textAlign:
                                                                  "center",
                                                                padding: "0px",
                                                              },
                                                              width: "100%",
                                                              marginRight: 1,
                                                            }}
                                                          />
                                                        </InputAdornment>
                                                      ),
                                                    }}
                                                    sx={{
                                                      borderRadius: "5px",
                                                      fontSize: "13px",
                                                      "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                                                        {
                                                          width:
                                                            "0px !important",
                                                          padding:
                                                            "9px 0px !important",
                                                        },
                                                      "& .css-1nuss9t": {
                                                        width: "0px !important",
                                                        padding:
                                                          "9px 0px !important",
                                                      },
                                                      // "& input": {
                                                      //   textAlign: "center",
                                                      //   padding: "0px",
                                                      // },
                                                      width: "100%",
                                                    }}
                                                  />
                                                </div>
                                              ) : (
                                                <div
                                                  className={`col-12 col-md-2 col-lg-1 pe-0 py-2`}
                                                >
                                                  <TextField
                                                    id="outlined-basic"
                                                    variant="outlined"
                                                    label={getPaceText(
                                                      value_data?.pace_type,
                                                    )}
                                                    InputLabelProps={{
                                                      className:
                                                        "textfiels-input-label",
                                                      shrink: true,
                                                      style: {
                                                        fontSize: "14px",
                                                      },
                                                    }}
                                                    InputProps={{
                                                      className:
                                                        "textfiels-input-value",
                                                      style: {
                                                        fontSize: "13px",
                                                        paddingLeft: "0px",
                                                        paddingRight: "0px",

                                                        justifyContent:
                                                          "center",
                                                      },
                                                      readOnly: true,
                                                      endAdornment: (
                                                        <InputAdornment
                                                          position="end"
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                          }}
                                                        >
                                                          <TextField
                                                            id="outlined-basic-minutes"
                                                            type="number"
                                                            size="small"
                                                            placeholder="Min"
                                                            name="pace"
                                                            value={formatWithLeadingZeros(
                                                              Math.floor(
                                                                value_data?.pace /
                                                                  60,
                                                              ),
                                                            )}
                                                            onChange={(e) =>
                                                              handleMinutesChange(
                                                                e,
                                                                index,
                                                                exerIndex,
                                                                selectedRound -
                                                                  1,
                                                              )
                                                            }
                                                            InputProps={{
                                                              className:
                                                                "textfiels-input-value",
                                                              style: {
                                                                fontSize:
                                                                  "14px",
                                                                // width: "40px",
                                                              },
                                                              readOnly: true,
                                                            }}
                                                            sx={{
                                                              "& fieldset": {
                                                                border: "none",
                                                              },
                                                              // "& .css-1j6hc4w-MuiInputBase-input-MuiOutlinedInput-input":
                                                              //   {
                                                              //     padding: "0px !important",
                                                              //   },
                                                              "& input": {
                                                                textAlign:
                                                                  "center",
                                                                padding: "0px",
                                                              },
                                                              width: "100%",
                                                            }}
                                                          />
                                                          <div className="fs-6 fw-semibold ms-1 ">
                                                            :
                                                          </div>

                                                          <TextField
                                                            id="outlined-basic-seconds"
                                                            type="number"
                                                            size="small"
                                                            placeholder="Sec"
                                                            name="pace"
                                                            value={formatWithLeadingZeros(
                                                              value_data?.pace %
                                                                60,
                                                            )}
                                                            onChange={(e) =>
                                                              handleSecondsChange(
                                                                e,
                                                                index,
                                                                exerIndex,
                                                                selectedRound -
                                                                  1,
                                                              )
                                                            }
                                                            InputProps={{
                                                              className:
                                                                "textfiels-input-value",
                                                              style: {
                                                                fontSize:
                                                                  "14px",
                                                                // width: "40px",
                                                              },
                                                              readOnly: true,
                                                            }}
                                                            sx={{
                                                              "& fieldset": {
                                                                border: "none",
                                                              },
                                                              // "& .css-1j6hc4w-MuiInputBase-input-MuiOutlinedInput-input":
                                                              //   {
                                                              //     padding: "0px !important",
                                                              //   },
                                                              "& input": {
                                                                textAlign:
                                                                  "center",
                                                                padding: "0px",
                                                              },
                                                              width: "100%",
                                                            }}
                                                          />
                                                        </InputAdornment>
                                                      ),
                                                    }}
                                                    sx={{
                                                      borderRadius: "5px",
                                                      fontSize: "13px",
                                                      "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                                                        {
                                                          width:
                                                            "0px !important",
                                                          padding:
                                                            "9px 0px !important",
                                                        },
                                                      "& .css-1nuss9t": {
                                                        width: "0px !important",
                                                        padding:
                                                          "9px 0px !important",
                                                      },
                                                      // "& input": {
                                                      //   textAlign: "center",
                                                      //   padding: "0px",
                                                      // },
                                                      width: "100%",
                                                    }}
                                                  />
                                                </div>
                                              )}
                                            </>
                                          )}
                                          {exerData.parameters.includes(
                                            "Pace",
                                          ) && (
                                            <>
                                              <div
                                                className={`col-12 col-md-3 col-lg-2 pe-0 py-2`}
                                              >
                                                <FormControl fullWidth>
                                                  <InputLabel
                                                    className="set-Type-lable"
                                                    sx={{
                                                      fontSize: "14px",
                                                    }}
                                                    id="demo-simple-select-label"
                                                  >
                                                    Type
                                                  </InputLabel>

                                                  <Select
                                                    className="set-Type-value"
                                                    id="select-option"
                                                    variant="outlined"
                                                    size="small"
                                                    name="race_type"
                                                    readOnly
                                                    value={
                                                      value_data?.race_type
                                                    }
                                                    label="Type"
                                                    inputProps={{
                                                      style: {
                                                        padding: 0,
                                                      },
                                                    }}
                                                    onChange={(e) => {
                                                      handleChangeEmomSet(
                                                        e,
                                                        index,
                                                        exerIndex,
                                                        selectedRound - 1,
                                                      );
                                                    }}
                                                    sx={{
                                                      width: "100%",
                                                      fontSize: "13px",
                                                      "& .MuiOutlinedInput-input":
                                                        {
                                                          paddingLeft: 1,
                                                          paddingRight:
                                                            "0px !important",
                                                        },
                                                    }}
                                                  >
                                                    <MenuItem value="el">
                                                      Easy/Long
                                                    </MenuItem>
                                                    <MenuItem value="c">
                                                      Compromised
                                                    </MenuItem>

                                                    <MenuItem value="i">
                                                      Interval
                                                    </MenuItem>
                                                    <MenuItem value="r">
                                                      Repitition
                                                    </MenuItem>
                                                  </Select>
                                                </FormControl>
                                              </div>
                                              <div
                                                className={`col-12 col-md-3 col-lg-2 pe-0 py-2`}
                                              >
                                                <TextField
                                                  sx={{
                                                    borderRadius: "5px",
                                                    paddingRight: 0,
                                                    width: "100%",
                                                  }}
                                                  size="small"
                                                  id="custom-input"
                                                  variant="outlined"
                                                  placeholder={"Distance"}
                                                  name="distance"
                                                  label="Distance"
                                                  value={value_data?.distance}
                                                  onChange={(e) => {
                                                    handleChangeEmomSet(
                                                      e,
                                                      index,
                                                      exerIndex,
                                                      selectedRound - 1,
                                                    );
                                                  }}
                                                  type="number"
                                                  InputLabelProps={{
                                                    className:
                                                      "textfiels-input-label",
                                                    shrink: true,

                                                    style: {
                                                      fontSize: "14px",
                                                    },
                                                  }}
                                                  InputProps={{
                                                    className:
                                                      "textfiels-input-value",
                                                    style: {
                                                      fontSize: "13px",
                                                      paddingRight: 0,
                                                    },
                                                    readOnly: true,
                                                    endAdornment: (
                                                      <InputAdornment position="end">
                                                        <Select
                                                          id="select-option"
                                                          variant="outlined"
                                                          size="small"
                                                          name="distanceType"
                                                          value={
                                                            value_data?.distanceType
                                                          }
                                                          label="Weight Type"
                                                          onChange={(e) => {
                                                            handleChangeEmomSet(
                                                              e,
                                                              index,
                                                              exerIndex,
                                                              selectedRound - 1,
                                                            );
                                                          }}
                                                          readOnly={true}
                                                          sx={{
                                                            "& legend": {
                                                              display: "none",
                                                            },
                                                            "& fieldset": {
                                                              top: 0,
                                                            },
                                                            fontSize: "13px",
                                                            border: "none",
                                                            "& fieldset": {
                                                              border: "none",
                                                            },
                                                          }}
                                                        >
                                                          <MenuItem value="m">
                                                            Meter
                                                          </MenuItem>
                                                          <MenuItem value="km">
                                                            KM
                                                          </MenuItem>
                                                          <MenuItem value="mi">
                                                            Mile
                                                          </MenuItem>
                                                        </Select>
                                                      </InputAdornment>
                                                    ),
                                                  }}
                                                />
                                              </div>
                                              <div
                                                className={`col-12 col-md-2 col-lg-2 pe-0 py-2`}
                                              >
                                                <TextField
                                                  id="outlined-basic"
                                                  variant="outlined"
                                                  label={getPaceTextinPaces(
                                                    value_data?.distanceType,
                                                  )}
                                                  InputLabelProps={{
                                                    className:
                                                      "textfiels-input-label",
                                                    shrink: true,
                                                    style: {
                                                      fontSize: "14px",
                                                    },
                                                  }}
                                                  InputProps={{
                                                    className:
                                                      "textfiels-input-value",
                                                    style: {
                                                      fontSize: "13px",
                                                      paddingLeft: "0px",
                                                      paddingRight: "0px",

                                                      justifyContent: "center",
                                                    },
                                                    readOnly: true,
                                                    endAdornment: (
                                                      <InputAdornment
                                                        position="end"
                                                        style={{
                                                          display: "flex",
                                                          alignItems: "center",
                                                        }}
                                                      >
                                                        <TextField
                                                          id="outlined-basic-minutes"
                                                          type="number"
                                                          size="small"
                                                          placeholder="Min"
                                                          name="pace"
                                                          value={formatWithLeadingZeros(
                                                            Math.floor(
                                                              value_data?.pace,
                                                            ),
                                                          )}
                                                          onChange={(e) =>
                                                            handleMinutesChangeSets(
                                                              e,
                                                              index,
                                                              exerIndex,
                                                              selectedRound - 1,
                                                            )
                                                          }
                                                          InputProps={{
                                                            className:
                                                              "textfiels-input-value",
                                                            style: {
                                                              fontSize: "14px",
                                                              // width: "40px",
                                                            },
                                                            readOnly: true,
                                                          }}
                                                          sx={{
                                                            "& fieldset": {
                                                              border: "none",
                                                            },
                                                            // "& .css-1j6hc4w-MuiInputBase-input-MuiOutlinedInput-input":
                                                            //   {
                                                            //     padding: "0px !important",
                                                            //   },
                                                            "& input": {
                                                              textAlign:
                                                                "center",
                                                              padding: "0px",
                                                            },
                                                            width: "100%",
                                                          }}
                                                        />
                                                        <div className="fs-6 fw-semibold ms-1 ">
                                                          :
                                                        </div>

                                                        <TextField
                                                          id="outlined-basic-seconds"
                                                          type="number"
                                                          size="small"
                                                          placeholder="Sec"
                                                          name="pace"
                                                          value={formatWithLeadingZeros(
                                                            value_data?.pace,
                                                          )}
                                                          onChange={(e) =>
                                                            handleSecondsChangeSets(
                                                              e,
                                                              index,
                                                              exerIndex,
                                                              selectedRound - 1,
                                                            )
                                                          }
                                                          InputProps={{
                                                            className:
                                                              "textfiels-input-value",
                                                            style: {
                                                              fontSize: "14px",
                                                              // width: "40px",
                                                            },
                                                            readOnly: true,
                                                          }}
                                                          sx={{
                                                            "& fieldset": {
                                                              border: "none",
                                                            },
                                                            // "& .css-1j6hc4w-MuiInputBase-input-MuiOutlinedInput-input":
                                                            //   {
                                                            //     padding: "0px !important",
                                                            //   },
                                                            "& input": {
                                                              textAlign:
                                                                "center",
                                                              padding: "0px",
                                                            },
                                                            width: "100%",
                                                          }}
                                                        />
                                                      </InputAdornment>
                                                    ),
                                                  }}
                                                  sx={{
                                                    borderRadius: "5px",
                                                    fontSize: "13px",
                                                    "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                                                      {
                                                        width: "0px !important",
                                                        padding:
                                                          "9px 0px !important",
                                                      },
                                                    "& .css-1nuss9t": {
                                                      width: "0px !important",
                                                      padding:
                                                        "9px 0px !important",
                                                    },
                                                    // "& input": {
                                                    //   textAlign: "center",
                                                    //   padding: "0px",
                                                    // },
                                                    width: "100%",
                                                  }}
                                                />
                                              </div>
                                              <div
                                                style={{
                                                  position: "absolute",
                                                  bottom: "4px",
                                                  left: "5px",
                                                }}
                                              >
                                                <Typography
                                                  variant="subtitle2"
                                                  sx={{
                                                    opacity: 0.6,
                                                    fontWeight: "600",
                                                    fontSize: "12px",
                                                  }}
                                                >{` @ Speed ${getKmhrForPace(
                                                  value_data?.distance,
                                                  value_data?.pace,
                                                  value_data?.distanceType,
                                                )} km/hr or ${getMihrForPace(
                                                  value_data?.distance,
                                                  value_data?.pace,
                                                  value_data?.distanceType,
                                                )} mi/hr`}</Typography>
                                              </div>
                                            </>
                                          )}
                                          {exerData?.parameters.includes(
                                            "Distance",
                                          ) && (
                                            <div
                                              className={`col-12 col-md-3 col-lg-2 pe-0 py-1`}
                                            >
                                              <TextField
                                                sx={{
                                                  borderRadius: "5px",
                                                  paddingRight: 0,
                                                  width: "100%",
                                                  marginTop: "5px",
                                                }}
                                                size="small"
                                                id="custom-input"
                                                variant="outlined"
                                                placeholder={"Distance"}
                                                name="distance"
                                                label="Distance"
                                                value={value_data?.distance}
                                                onChange={(e) => {
                                                  handleChangeEmomSet(
                                                    e,
                                                    index,
                                                    exerIndex,
                                                    selectedRound - 1,
                                                  );
                                                }}
                                                type="number"
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                    paddingRight: 0,
                                                  },

                                                  endAdornment: (
                                                    <InputAdornment position="end">
                                                      <Select
                                                        id="select-option"
                                                        variant="outlined"
                                                        size="small"
                                                        name="distanceType"
                                                        value={
                                                          value_data?.distanceType
                                                        }
                                                        label="Weight Type"
                                                        onChange={(e) => {
                                                          handleChangeEmomSet(
                                                            e,
                                                            index,
                                                            exerIndex,
                                                            setIndex,
                                                          );
                                                        }}
                                                        sx={{
                                                          "& legend": {
                                                            display: "none",
                                                          },
                                                          "& fieldset": {
                                                            top: 0,
                                                          },
                                                          fontSize: "13px",
                                                          border: "none",
                                                          "& fieldset": {
                                                            border: "none",
                                                          },
                                                        }}
                                                      >
                                                        <MenuItem value="m">
                                                          Meter
                                                        </MenuItem>
                                                        <MenuItem value="km">
                                                          KM
                                                        </MenuItem>
                                                        <MenuItem value="mi">
                                                          Mile
                                                        </MenuItem>
                                                      </Select>
                                                    </InputAdornment>
                                                  ),
                                                }}
                                              />
                                            </div>
                                          )}
                                          {(exerData.parameters.includes(
                                            "Duration/Pace",
                                          ) ||
                                            exerData.parameters.includes(
                                              "Time",
                                            )) && (
                                            <div
                                              className={`col-12 col-md-3 col-lg-2 pe-0 py-2`}
                                            >
                                              <TextField
                                                id="outlined-basic"
                                                size="small"
                                                variant="outlined"
                                                placeholder="0"
                                                type="number"
                                                value={value_data?.time}
                                                name="time"
                                                onChange={(e) => {
                                                  handleChangeEmomSet(
                                                    e,
                                                    index,
                                                    exerIndex,
                                                    selectedRound - 1,
                                                  );
                                                }}
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                label="Duration/Pace"
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                    paddingRight: 0,
                                                  },

                                                  endAdornment: (
                                                    <InputAdornment position="end">
                                                      <Select
                                                        id="select-option"
                                                        variant="outlined"
                                                        size="small"
                                                        name="timeType"
                                                        value={
                                                          value_data?.timeType
                                                        }
                                                        label="Weight Type"
                                                        inputProps={{
                                                          style: {
                                                            padding: 0,
                                                          },
                                                        }}
                                                        onChange={(e) => {
                                                          handleChangeEmomSet(
                                                            e,
                                                            index,
                                                            exerIndex,
                                                            selectedRound - 1,
                                                          );
                                                        }}
                                                        sx={{
                                                          "& legend": {
                                                            display: "none",
                                                          },
                                                          "& fieldset": {
                                                            top: 0,
                                                          },
                                                          fontSize: "13px",
                                                          border: "none",
                                                          "& fieldset": {
                                                            border: "none",
                                                          },
                                                          "& .MuiOutlinedInput-input":
                                                            {
                                                              padding: 0,
                                                            },
                                                        }}
                                                      >
                                                        <MenuItem value="sec">
                                                          sec
                                                        </MenuItem>
                                                        <MenuItem value="min">
                                                          min
                                                        </MenuItem>
                                                      </Select>
                                                    </InputAdornment>
                                                  ),
                                                }}
                                                sx={{
                                                  borderRadius: "5px",
                                                  fontSize: "13px",
                                                  width: "100%",
                                                }}
                                              />
                                            </div>
                                          )}

                                          {exerData.parameters.includes(
                                            "Reps",
                                          ) && (
                                            <div className="col-12 col-md-2 col-lg-1 pe-0 py-2">
                                              <TextField
                                                id="outlined-basic"
                                                size="small"
                                                variant="outlined"
                                                placeholder="Reps"
                                                type="text"
                                                label="Reps"
                                                value={value_data?.reps}
                                                name="reps"
                                                onChange={(e) => {
                                                  handleChangeEmomSet(
                                                    e,
                                                    index,
                                                    exerIndex,
                                                    selectedRound - 1,
                                                  );
                                                }}
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                  },
                                                }}
                                                sx={{
                                                  borderRadius: "5px",
                                                  // "& legend": { display: "none" },
                                                  // "& fieldset": { top: 0 },
                                                  fontSize: "13px",
                                                  // width: "13%",
                                                  width: "100%",
                                                }}
                                              />
                                            </div>
                                          )}
                                          {exerData.parameters.includes(
                                            "Watts",
                                          ) && (
                                            <div className="col-12 col-md-2 col-lg-1 pe-0 py-2">
                                              <TextField
                                                id="outlined-basic"
                                                size="small"
                                                variant="outlined"
                                                placeholder="Watts"
                                                type="number"
                                                label="Watts"
                                                value={value_data?.watts}
                                                name="watts"
                                                onChange={(e) => {
                                                  handleChangeEmomSet(
                                                    e,
                                                    index,
                                                    exerIndex,
                                                    selectedRound - 1,
                                                  );
                                                }}
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                  },
                                                }}
                                                sx={{
                                                  borderRadius: "5px",
                                                  fontSize: "13px",
                                                  width: "100%",
                                                }}
                                              />
                                            </div>
                                          )}
                                          {exerData.parameters.includes(
                                            "Max_Reps",
                                          ) && (
                                            <div className="col-12 col-md-2 col-lg-1 pe-0 py-2">
                                              <TextField
                                                id="outlined-basic"
                                                size="small"
                                                variant="outlined"
                                                placeholder="Max Reps"
                                                type="number"
                                                label="Max Reps"
                                                value={value_data?.maxReps}
                                                name="maxReps"
                                                onChange={(e) => {
                                                  handleChangeEmomSet(
                                                    e,
                                                    index,
                                                    exerIndex,
                                                    selectedRound - 1,
                                                  );
                                                }}
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                  },
                                                }}
                                                sx={{
                                                  borderRadius: "5px",
                                                  // "& legend": { display: "none" },
                                                  // "& fieldset": { top: 0 },
                                                  fontSize: "13px",
                                                  // width: "13%",
                                                  width: "100%",
                                                }}
                                              />
                                            </div>
                                          )}
                                          {exerData.parameters.includes(
                                            "Height",
                                          ) && (
                                            <div className="col-12 col-md-3 col-lg-2 pe-0 py-2">
                                              <TextField
                                                id="outlined-basic"
                                                size="small"
                                                variant="outlined"
                                                placeholder="0"
                                                type="number"
                                                value={value_data?.height}
                                                name="height"
                                                onChange={(e) => {
                                                  handleChangeEmomSet(
                                                    e,
                                                    index,
                                                    exerIndex,
                                                    selectedRound - 1,
                                                  );
                                                }}
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                label="Height"
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                    paddingRight: 0,
                                                  },
                                                  endAdornment: (
                                                    <InputAdornment position="end">
                                                      <Select
                                                        id="select-option"
                                                        variant="outlined"
                                                        size="small"
                                                        name="height_unit"
                                                        value={
                                                          value_data?.height_unit
                                                        }
                                                        label="Weight Type"
                                                        inputProps={{
                                                          style: {
                                                            padding: 0,
                                                          },
                                                        }}
                                                        onChange={(e) => {
                                                          handleChangeEmomSet(
                                                            e,
                                                            index,
                                                            exerIndex,
                                                            selectedRound - 1,
                                                          );
                                                        }}
                                                        sx={{
                                                          "& legend": {
                                                            display: "none",
                                                          },
                                                          "& fieldset": {
                                                            top: 0,
                                                          },
                                                          fontSize: "13px",
                                                          border: "none",
                                                          "& fieldset": {
                                                            border: "none",
                                                          },
                                                          "& .MuiOutlinedInput-input":
                                                            {
                                                              padding: 0,
                                                            },
                                                        }}
                                                      >
                                                        <MenuItem value="cm">
                                                          Cm
                                                        </MenuItem>
                                                        <MenuItem value="ft">
                                                          Feet
                                                        </MenuItem>
                                                        <MenuItem value="inch">
                                                          Inch
                                                        </MenuItem>
                                                      </Select>
                                                    </InputAdornment>
                                                  ),
                                                }}
                                                sx={{
                                                  borderRadius: "5px",
                                                  fontSize: "13px",
                                                  width: "100%",
                                                }}
                                              />
                                            </div>
                                          )}
                                          {exerData.parameters.includes(
                                            "Weight",
                                          ) && (
                                            <div className="col-12 col-md-4 col-lg-2 pe-0 py-2">
                                              <TextField
                                                sx={{
                                                  borderRadius: "5px",
                                                  paddingRight: 0,
                                                  width: "100%",
                                                }}
                                                size="small"
                                                id="custom-input"
                                                variant="outlined"
                                                placeholder="Weight"
                                                name="weight"
                                                label="Weight"
                                                value={value_data?.weight}
                                                onChange={(e) => {
                                                  handleChangeEmomSet(
                                                    e,
                                                    index,
                                                    exerIndex,
                                                    selectedRound - 1,
                                                  );
                                                }}
                                                type="number"
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                    paddingRight: 0,
                                                  },
                                                  endAdornment: (
                                                    <InputAdornment position="end">
                                                      <Select
                                                        id="select-option"
                                                        variant="outlined"
                                                        size="small"
                                                        name="weightType"
                                                        value={
                                                          value_data?.weightType
                                                        }
                                                        label="Weight Type"
                                                        onChange={(e) => {
                                                          handleChangeEmomSet(
                                                            e,
                                                            index,
                                                            exerIndex,
                                                            selectedRound - 1,
                                                          );
                                                        }}
                                                        sx={{
                                                          "& legend": {
                                                            display: "none",
                                                          },
                                                          "& fieldset": {
                                                            top: 0,
                                                          },
                                                          fontSize: "13px",
                                                          border: "none",
                                                          "& fieldset": {
                                                            border: "none",
                                                          },
                                                        }}
                                                      >
                                                        <MenuItem value="1rm">
                                                          % 1RM
                                                        </MenuItem>
                                                        <MenuItem value="body_weight">
                                                          % BW
                                                        </MenuItem>
                                                        <MenuItem value="kg">
                                                          KG
                                                        </MenuItem>
                                                        <MenuItem value="lb">
                                                          Pound
                                                        </MenuItem>
                                                        <MenuItem value="poods">
                                                          Poods
                                                        </MenuItem>
                                                      </Select>
                                                    </InputAdornment>
                                                  ),
                                                }}
                                              />
                                            </div>
                                          )}
                                          {exerData.parameters.includes(
                                            "Distance/Calories",
                                          ) && (
                                            <div className="col-12 col-md-3 col-lg-2 pe-0 py-2">
                                              <TextField
                                                sx={{
                                                  borderRadius: "5px",
                                                  paddingRight: 0,
                                                  width: "100%",
                                                }}
                                                size="small"
                                                id="custom-input"
                                                variant="outlined"
                                                placeholder={
                                                  value_data?.distanceType ==
                                                  "calories"
                                                    ? "Calories"
                                                    : "Distance"
                                                }
                                                name="distance"
                                                label="Distance/Calories"
                                                value={value_data?.distance}
                                                onChange={(e) => {
                                                  handleChangeEmomSet(
                                                    e,
                                                    index,
                                                    exerIndex,
                                                    selectedRound - 1,
                                                  );
                                                }}
                                                type="number"
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                    paddingRight: 0,
                                                  },
                                                  endAdornment: (
                                                    <InputAdornment position="end">
                                                      <Select
                                                        id="select-option"
                                                        variant="outlined"
                                                        size="small"
                                                        name="distanceType"
                                                        value={
                                                          value_data?.distanceType
                                                        }
                                                        label="Weight Type"
                                                        onChange={(e) => {
                                                          handleChangeEmomSet(
                                                            e,
                                                            index,
                                                            exerIndex,
                                                            selectedRound - 1,
                                                          );
                                                        }}
                                                        sx={{
                                                          "& legend": {
                                                            display: "none",
                                                          },
                                                          "& fieldset": {
                                                            top: 0,
                                                          },
                                                          fontSize: "13px",
                                                          border: "none",
                                                          "& fieldset": {
                                                            border: "none",
                                                          },
                                                          "& .MuiOutlinedInput-input":
                                                            {
                                                              padding: 0,
                                                            },
                                                        }}
                                                      >
                                                        <MenuItem value="m">
                                                          Meter
                                                        </MenuItem>
                                                        <MenuItem value="km">
                                                          KM
                                                        </MenuItem>
                                                        <MenuItem value="mi">
                                                          Mile
                                                        </MenuItem>
                                                        <MenuItem value="calories">
                                                          Calories
                                                        </MenuItem>
                                                      </Select>
                                                    </InputAdornment>
                                                  ),
                                                }}
                                              />
                                            </div>
                                          )}
                                          {exerData.parameters.includes(
                                            "%MHR",
                                          ) && (
                                            <div className="col-12 col-md-2 col-lg-1 pe-0 py-2">
                                              <TextField
                                                id="outlined-basic"
                                                size="small"
                                                variant="outlined"
                                                placeholder="%MHR"
                                                type="number"
                                                label="%MHR"
                                                value={value_data?.mhr}
                                                name="mhr"
                                                onChange={(e) => {
                                                  handleChangeEmomSetTempo(
                                                    e,
                                                    index,
                                                    exerIndex,
                                                    selectedRound - 1,
                                                  );
                                                }}
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                  },
                                                }}
                                                sx={{
                                                  borderRadius: "5px",

                                                  fontSize: "13px",
                                                  width: "100%",
                                                  "& .MuiOutlinedInput-input": {
                                                    padding: "8px 7px",
                                                  },
                                                }}
                                              />
                                            </div>
                                          )}
                                          {exerData.parameters.includes(
                                            "RPE",
                                          ) && (
                                            <div className="col-12 col-md-2 col-lg-1 pe-0 py-2">
                                              <TextField
                                                id="outlined-basic"
                                                size="small"
                                                variant="outlined"
                                                placeholder="RPE"
                                                label="RPE"
                                                value={value_data?.RPE}
                                                name="RPE"
                                                onChange={(e) => {
                                                  handleChangeEmomSet(
                                                    e,
                                                    index,
                                                    exerIndex,
                                                    selectedRound - 1,
                                                  );
                                                }}
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                  },
                                                }}
                                                sx={{
                                                  borderRadius: "5px",

                                                  fontSize: "13px",
                                                  width: "100%",
                                                  "& .MuiOutlinedInput-input": {
                                                    padding: "8px 7px",
                                                  },
                                                }}
                                              />
                                            </div>
                                          )}
                                          {exerData.parameters.includes(
                                            "Tempo",
                                          ) && (
                                            <div className="col-12 col-md-2 col-lg-1 pe-0 py-2">
                                              <TextField
                                                id="outlined-basic"
                                                size="small"
                                                variant="outlined"
                                                placeholder="Tempo"
                                                type="number"
                                                label="Tempo"
                                                value={value_data?.tempo}
                                                name="tempo"
                                                onChange={(e) => {
                                                  handleChangeEmomSetTempo(
                                                    e,
                                                    index,
                                                    exerIndex,
                                                    selectedRound - 1,
                                                  );
                                                }}
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                  },
                                                  // readOnly: true,
                                                }}
                                                sx={{
                                                  borderRadius: "5px",

                                                  fontSize: "13px",
                                                  width: "100%",
                                                  "& .MuiOutlinedInput-input": {
                                                    padding: "8px 7px",
                                                  },
                                                }}
                                              />
                                            </div>
                                          )}
                                          {exerData.parameters.includes(
                                            "Rest",
                                          ) && (
                                            <div className="col-12 col-md-3 col-lg-2 pe-0 py-2">
                                              <TextField
                                                id="outlined-basic"
                                                size="small"
                                                variant="outlined"
                                                placeholder="0"
                                                type="number"
                                                value={value_data?.rest}
                                                name="rest"
                                                onChange={(e) => {
                                                  handleChangeEmomSet(
                                                    e,
                                                    index,
                                                    exerIndex,
                                                    selectedRound - 1,
                                                  );
                                                }}
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                label="Rest"
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                    paddingRight: 0,
                                                  },
                                                  endAdornment: (
                                                    <InputAdornment position="end">
                                                      <Select
                                                        id="select-option"
                                                        variant="outlined"
                                                        size="small"
                                                        name="restType"
                                                        value={
                                                          value_data?.restType
                                                        }
                                                        label="Weight Type"
                                                        inputProps={{
                                                          style: {
                                                            padding: 0,
                                                          },
                                                        }}
                                                        onChange={(e) => {
                                                          handleChangeEmomSet(
                                                            e,
                                                            index,
                                                            exerIndex,
                                                            selectedRound - 1,
                                                          );
                                                        }}
                                                        sx={{
                                                          "& legend": {
                                                            display: "none",
                                                          },
                                                          "& fieldset": {
                                                            top: 0,
                                                          },
                                                          fontSize: "13px",
                                                          border: "none",
                                                          "& fieldset": {
                                                            border: "none",
                                                          },
                                                          "& .MuiOutlinedInput-input":
                                                            {
                                                              padding: 0,
                                                            },
                                                        }}
                                                      >
                                                        <MenuItem value="sec">
                                                          sec
                                                        </MenuItem>
                                                        <MenuItem value="min">
                                                          min
                                                        </MenuItem>
                                                      </Select>
                                                    </InputAdornment>
                                                  ),
                                                }}
                                                sx={{
                                                  borderRadius: "5px",
                                                  fontSize: "13px",
                                                  width: "100%",
                                                }}
                                              />
                                            </div>
                                          )}
                                          {exerData?.parameters.includes(
                                            "Vdot",
                                          ) && (
                                            <div>
                                              {value_data?.race_type == "el" ? (
                                                <Typography
                                                  variant="subtitle2"
                                                  sx={{
                                                    opacity: 0.6,
                                                    fontWeight: "600",
                                                    fontSize: "12px",
                                                  }}
                                                >{` @ Speed ${getKmhr(
                                                  value_data?.pace,
                                                  value_data?.pace_type,
                                                )} km/hr or ${getMihr(
                                                  value_data?.pace,
                                                  value_data?.pace_type,
                                                )} mi/hr -  ${getKmhr(
                                                  value_data?.paceUp,
                                                  value_data?.pace_type,
                                                )} km/hr or ${getMihr(
                                                  value_data?.paceUp,
                                                  value_data?.pace_type,
                                                )} mi/hr`}</Typography>
                                              ) : (
                                                <Typography
                                                  variant="subtitle2"
                                                  sx={{
                                                    opacity: 0.6,
                                                    fontWeight: "600",
                                                    fontSize: "12px",
                                                  }}
                                                >{` @ Speed ${getKmhr(
                                                  value_data?.pace,
                                                  value_data?.pace_type,
                                                )} km/hr or ${getMihr(
                                                  value_data?.pace,
                                                  value_data?.pace_type,
                                                )} mi/hr`}</Typography>
                                              )}
                                            </div>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  )
                                  // ))
                                }
                              </Box>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                );
              })}
            <div className="row  justify-content-between align-items-center">
              <div className="col-12 col-md-8 col-lg-10 pe-0"></div>
              <div className="col-12 col-md-4 col-lg-2 pe-0">
                <div className="d-flex justify-content-end mt-3">
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          disabled={
                            addArray[
                              mainindex
                            ]?.emomSets[0][0]?.parameters?.includes("Vdot") &&
                            !member_vdot
                          }
                          sx={{ p: "3px" }}
                          checked={addArray[mainindex].is_completed}
                          onChange={(e) => handleChangeComplete(e, mainindex)}
                        />
                      }
                      label="Mark as Complete"
                    />
                  </FormGroup>
                </div>
              </div>
            </div>
          </Box>
        </div>
      </div>
    </div>
  );
};
export default EMOMExercisesUI;
